import ReactModal from 'react-modal';
import { useModal } from 'react-modal-hook';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import FontIcon from 'components/icons';

import './styles/blog-search.scss';
import CloseBtn from '../buttons/button-close';
import BlogSearch from '../search/blog-search';
ReactModal.setAppElement('#___gatsby');

type BlogSearchProps = {
  button_text?: string;
  className?: string;
};

const searchIndices = [{ name: 'Posts' }];

const BlogSearchModal = ({
  className,
  button_text,
}:BlogSearchProps) => {
  const breakpoints = useBreakpoint();
  // This component needs the modal state to update based on
  // the success of the input field. You need to add the state updates inside the hooked modal component
  //  which is why this modal looks a little different than others.

  const [showModal, hideModal] = useModal(({ onExited }) => {
    const closeModal = () => {
      // @ts-ignore
      if ('virtualKeyboard' in window.navigator) window.navigator.virtualKeyboard.overlaysContent = false;
      hideModal();
    };

    return (
      <ReactModal
        isOpen
        onAfterClose={ onExited }
        onRequestClose={ hideModal }
        className="default-modal-wrapper blog-search-modal"
        overlayClassName="default-modal-overlay"
      >
        <section
          data-section="BlogSearchModal"
          className="blog-search-modal-container"
        >
          <CloseBtn onClick={ () => closeModal() } />
          <BlogSearch indices={ searchIndices } />
        </section>
      </ReactModal>
    );
  });
  return (
    <button
      className={ `button blog-search-button ${
        className !== undefined ? className : ''
      }` }
      type="button"
      onClick={ showModal }
    >
      <FontIcon icon="search" /> {!breakpoints.sm && (button_text ?? 'Search')}
    </button>
  );
};

export default BlogSearchModal;
